export default __webpack_public_path__ + "static/media/double_bg2.f49b3efc.png";